import { MessageOutlined } from "@ant-design/icons";

/** Màn hình chào khi chưa có tin nhắn; gợi ý câu hỏi nằm ở chip phía trên ô nhập */
export default function SuggestionCards() {
  return (
    <div className="flex-1 overflow-y-auto">
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col items-start">
          <div
            className="w-10 h-10 rounded-lg border border-slate-200 flex items-center justify-center mb-6 text-slate-900"
            style={{ color: "var(--primary-color)" }}
          >
            <MessageOutlined className="text-lg" />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight mb-2">
            Trợ lý DVN
          </h1>
          <p className="text-base text-slate-500 max-w-lg mb-2">
            Tra cứu khách hàng, chỉ số nước, hoá đơn và giao dịch. Dữ liệu được
            truy vấn trực tiếp từ hệ thống.
          </p>
          <p className="text-sm text-slate-400 max-w-lg">
            Chọn một gợi ý thống kê phía trên ô nhập để điền sẵn câu hỏi — bạn có
            thể chỉnh sửa trước khi gửi.
          </p>
        </div>
      </div>
    </div>
  );
}
